import PrimeVue from 'primevue/config';
import MedmasteryLaraPreset from '~/theme/lara-preset';
import DialogService from 'primevue/dialogservice';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import pt from '~/theme/global-pt';

export default defineNuxtPlugin(app => {
  app.vueApp.use(PrimeVue, {
    theme: {
      preset: MedmasteryLaraPreset,
      options: {
        cssLayer: {
          name: 'primevue',
          order: 'theme, base, primevue, utilities',
        },
        darkModeSelector: false,
      },
    },
    ptOptions: {
      mergeSections: true,
      mergeProps: true,
    },
    pt,
  });

  app.vueApp.use(DialogService);
  app.vueApp.use(ToastService);
  app.vueApp.use(ConfirmationService);
});